<ms-gh-next-races *ngIf="nextFixtures.length" [nextFixtures]="nextFixtures"></ms-gh-next-races>
<ms-error *ngIf="!nextFixtures.length" [links]="false" [message]="sitecore.horseRacing.tournaments.ErrNoTodayRaces" [severity]="'info'"></ms-error>
